export default __webpack_public_path__ + "static/media/todoMobile.8b643448.jpg";